module.exports = __webpack_public_path__ + "img/EXTERIOR-BALENO-5.37234dcb.jpg";